import { Container } from 'unstated';

import { TitleAlignmentType } from '@confluence/content-topper/entry-points/contentTopperConstants.ts';

export class AlignmentButtonContainer extends Container<any> {
	state: {
		alignmentButtonState: TitleAlignmentType;
		isUpdatingAlignment: boolean;
		isLoadingComplete: boolean;
	} = {
		alignmentButtonState: TitleAlignmentType.LEFT,
		isUpdatingAlignment: false,
		isLoadingComplete: false,
	};

	toggleAlignmentButton = (newAlignmentState?: TitleAlignmentType): void => {
		if (this.state.alignmentButtonState !== newAlignmentState) {
			void this.setState({
				alignmentButtonState: newAlignmentState || TitleAlignmentType.LEFT,
			});
		}
	};

	setIsLoadingComplete = (isLoadingComplete: boolean): void => {
		void this.setState({ isLoadingComplete });
	};
	setIsUpdatingAlignment = (isUpdatingAlignment: boolean): void => {
		void this.setState({ isUpdatingAlignment });
	};
	resetToDefaults = (): void => {
		void this.setState({
			alignmentButtonState: TitleAlignmentType.LEFT,
			isUpdatingAlignment: false,
			isLoadingComplete: false,
		});
	};
}
